import React, { Fragment } from "react";
import { notUndefinedAndNull } from "../utils/Validation";

export default class Icon extends React.Component {

  renderImage(){
    let image = this.props.image;

    if(notUndefinedAndNull(image)){
      return <img src={this.props.image} alt="" className={this.props.className ? this.props.className : "sp-icon"} /> 
    }
  }

  getIcon(){
    switch(this.props.icon){
      case "pending":
        return "icon pending icon_regular qicon-pending"
      case "success":
        return "icon successful icon_regular qicon-successful";
      case "filter":
        return "icon filter click qicon-filter icon icon_small";
      case "cross":
        return "icon declined icon_regular qicon-decline";
      case "fee-payment":
        return "icon icon_regular qicon-fees_payment";
      case "circulars":
        return "icon icon_regular qicon-circulars";
      case "stats":
        return "icon icon_regular qicon-attendance_statistics";
      case "timetable":
        return "icon icon_regular qicon-timetable";
      case "search":
        return "qicon-search search-icon icon icon_small";
      case "open":
        return "icon open icon_regular qicon-time";
      case "delete":
        return "icon-delete";

  
      default:
        return "";
    }
  }

  getClassName(){
    let {click, labelClass} = this.props;
    let className = "";
    if(click){
      className = className + " click";
    }else{
      className = className + " noclick";
    }

    if(labelClass){
      className = className + " " + labelClass;
    }else{
      className = className + " " + this.getIcon();
    }

    return className;
  }
  

  render() {
    return (
      <Fragment>
        {this.renderImage()}
        <span className={this.getClassName()} onClick={this.props.onClick}>{" "}{this.props.label}{this.props.children}</span>
      </Fragment>
    );
  }
}
